import { Accordion } from "flowbite-react"

const ShopifyFAQ: React.FC = () => {
  return (
    <>
      <Accordion>
        <Accordion.Panel>
          <Accordion.Title as="h3" className="accordion-title">
            What is Shopify website development?
          </Accordion.Title>
          <Accordion.Content className="accordion-border">
            <div className="fs-md mb-0 text-secondary">
              Shopify website development is the process of designing, building,
              and launching an e-commerce website using the Shopify platform.
              This involves creating a custom theme or template, configuring the
              site&#39;s settings and features, integrating with third-party
              apps and tools, and optimizing the site for performance and SEO.
            </div>
          </Accordion.Content>
        </Accordion.Panel>
        <Accordion.Panel>
          <Accordion.Title as="h3" className="accordion-title">
            {" "}
            What can I expect from your Shopify development services?
          </Accordion.Title>
          <Accordion.Content className="accordion-border">
            <div className="fs-md mb-0 text-secondary">
              Our Shopify development services can help you build a successful
              online store along with the below advantages: A fully customized
              Shopify store that aligns with your brand and business needs -{" "}
              <br />
              <ul className="list mb-0 mt-3">
                <li>
                  A user-friendly and intuitive shopping experience for your
                  customers
                </li>
                <li>
                  Seamless third-party app integration to enhance your stores
                  functionality
                </li>
                <li>
                  Ongoing maintenance and support to ensure your store runs
                  smoothly
                </li>
                <li>
                  Training and education to empower you to manage your store
                  effectively.
                </li>
              </ul>
            </div>
          </Accordion.Content>
        </Accordion.Panel>
        <Accordion.Panel>
          <Accordion.Title as="h3" className="accordion-title">
            {" "}
            Why should I choose Shopify for my e-commerce website?
          </Accordion.Title>
          <Accordion.Content className="accordion-border">
            <div className="fs-md mb-0 text-secondary">
              Shopify offers a wide range of features and tools specifically
              designed for e-commerce, including easy product and inventory
              management, customizable themes and templates, secure payment
              processing, and powerful analytics and reporting. Additionally,
              Shopify is highly scalable and can accommodate businesses of all
              sizes, from small start-ups to large enterprises.
            </div>
          </Accordion.Content>
        </Accordion.Panel>
        <Accordion.Panel>
          <Accordion.Title as="h3" className="accordion-title">
            How long does it take to develop a Shopify website?
          </Accordion.Title>
          <Accordion.Content className="accordion-border">
            <div className="fs-md mb-0 text-secondary">
              The timeline for Shopify website development can vary depending on
              the complexity of the site and the specific requirements of the
              project. Typically, a simple Shopify store can be launched in a
              matter of weeks, while more complex sites may take several months
              or longer to complete.
            </div>
          </Accordion.Content>
        </Accordion.Panel>
        <Accordion.Panel>
          <Accordion.Title as="h3" className="accordion-title">
            What is the cost of developing a Shopify e-commerce website?
          </Accordion.Title>
          <Accordion.Content className="accordion-border">
            <div className="fs-md mb-0 text-secondary">
              The cost of developing a Shopify e-commerce website can vary
              greatly depending on a number of factors such as the complexity of
              the design, the number of features and functionality required, the
              size of the product catalog, and the level of customization
              needed.
            </div>
          </Accordion.Content>
        </Accordion.Panel>
      </Accordion>
    </>
  )
}

export default ShopifyFAQ
